"use client";

import React from "react";
import {NotificationAction} from "@/components/notifications/NotificationAction";
import {NotificationIcon} from "@/components/notifications/NotificationIcon";
import {NotificationItem} from "@/components/notifications/NotificationItem";
import {resolveAccountNotificationContent} from "@/components/notifications/notificationContent";
import type {NotificationDictionary} from "@/components/notifications/NotificationDrawer";
import type {Locale} from "@/i18n-config";
import type {AccountVerifiedNotification} from "@/utils/notifications/account/types";

export function AccountVerifiedNotification({
    notification,
    locale,
    dictionary,
    onMarkRead,
    onInternalNavigate,
}: {
    notification: AccountVerifiedNotification;
    locale: Locale;
    dictionary: NotificationDictionary;
    onMarkRead: (notificationId: string) => void | Promise<void>;
    onInternalNavigate: () => void;
}) {
    const content = resolveAccountNotificationContent(
        notification,
        locale,
        dictionary,
    );

    return (
        <NotificationItem
            id={notification.id}
            locale={locale}
            publishedAt={notification.published_at}
            readAt={notification.read_at}
            icon={<NotificationIcon type={notification.type} />}
            label={content.category}
            title={content.title}
            description={content.description}
            sticky={notification.sticky}
            stickyLabel={dictionary.notificationCenterPinned}
            action={(
                <NotificationAction
                    locale={locale}
                    href="/account"
                    label={dictionary.notificationAccountVerifiedAction}
                    onActivate={() => onMarkRead(notification.id)}
                    onInternalNavigate={onInternalNavigate}
                    className="text-sm font-semibold text-grass-700 hover:text-grass-900"
                />
            )}
            markReadLabel={dictionary.notificationCenterMarkRead}
            showMoreLabel={dictionary.notificationCenterShowMore}
            showLessLabel={dictionary.notificationCenterShowLess}
            onMarkRead={onMarkRead}
        />
    );
}
